import { deactivateIntegration } from '@/features/AudienceManager/services';
export const deactivateIntegrations = (params) => {
    return deactivateIntegration(params).then(response => {
        const integration = response?.data;
        return {
            scheduleId: integration?.data?.scheduleId,
            success: integration?.success,
        };
    });
};
